import {createRoot} from 'react-dom/client'
// Axios
import axios from 'axios'
import {QueryClient, QueryClientProvider} from 'react-query'
// Apps
import './_metronic/assets/fonticon/fonticon.css'
import './_metronic/assets/keenicons/duotone/style.css'
import './_metronic/assets/keenicons/outline/style.css'
import './_metronic/assets/keenicons/solid/style.css'
import './_metronic/assets/print-style.css'
import {I18nextProvider} from 'react-i18next'
import i18n from './i18n'

import './_metronic/assets/rtl/style.rtl.css'

import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'
import {AppRoutes} from './app/routing/AppRoutes'
import {AuthProvider, setupAxios} from './app/modules/auth'
import './i18n'
import {store} from './redux/store'
import {Provider} from 'react-redux'

axios.defaults.baseURL = process.env.REACT_APP_API_URL

setupAxios(axios)

const queryClient = new QueryClient()
const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <I18nextProvider i18n={i18n}>
          <AuthProvider>
            <AppRoutes />
            {/* <ChatListener /> */}
          </AuthProvider>
        </I18nextProvider>
      </QueryClientProvider>
    </Provider>
  )
}